var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"app-bg",style:(_vm.bgStyle)}),_c('div',{staticClass:"cursor-trail"},_vm._l((_vm.trail),function(p,index){return _c('div',{key:index,staticClass:"cursor-dot",style:({
        transform: 'translate3d(' + p.x + 'px,' + p.y + 'px,0)',
        opacity: p.opacity,
        background: p.color
      })})}),0),_c('router-view'),_c('GlobalMusicPlayer'),_c('ClickEffects')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }